export default __webpack_public_path__ + "static/media/hospital1.bf4b578f.jpg";